import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" {...props}><g fill="none" fillRule="evenodd"><path d="M0 0h18v18H0z" /><g transform="translate(1 1)" stroke="#1862D2" strokeWidth="1.6"><circle cx="8.02" cy="5.18" r="3.94" /><circle cx="6.5" cy="6.65" r="6.11" /><circle cx="8" cy="8" r="8" /></g></g></svg>;